@if (Company && LocalizationInfo && ProposalRequest) {
  <div class="container-fluid p-0">
    <!-- Bid overview: name, site, location, contact -->
    <div class="row mb-3">
      <div class="col">
        <app-display-card [innerPanel]="true">
          <div class="qsb-section-head">
            <h3 class="mb-0">Bid overview</h3>
          </div>
          <div class="row g-3">
            <div class="col-md-6">
              <dl class="review-list">
                <div class="review-row">
                  <dt>Bid name</dt>
                  <dd>{{ ProposalRequest.name }}</dd>
                </div>
                <div class="review-row">
                  <dt>Site</dt>
                  <dd>{{ ProposalRequest.Site?.legalName || '—' }}</dd>
                </div>
                <div class="review-row">
                  <dt>Work location</dt>
                  <dd>
                    {{ ProposalRequest.Address?.address1 }}
                    {{ ProposalRequest.Address?.address2 || '' }}<br />
                    {{ ProposalRequest.Address?.city }},
                    {{ ProposalRequest.Address?.state || '' }}
                    {{ ProposalRequest.Address?.zip }}
                  </dd>
                </div>
              </dl>
            </div>
            <div class="col-md-6">
              <dl class="review-list">
                <div class="review-row">
                  <dt>Contact name</dt>
                  <dd>
                    {{ ProposalRequest.contactFirstName }}
                    {{ ProposalRequest.contactLastName }}
                  </dd>
                </div>
                <div class="review-row">
                  <dt>Contact phone</dt>
                  <dd>{{ ProposalRequest.contactPhone }}</dd>
                </div>
                @if (ProposalRequest.contactPhone2) {
                  <div class="review-row">
                    <dt>Work phone</dt>
                    <dd>{{ ProposalRequest.contactPhone2 }}</dd>
                  </div>
                }
                @if (ProposalRequest.contactEmail) {
                  <div class="review-row">
                    <dt>Contact email</dt>
                    <dd>
                      @for (
                        email of displayEmails(ProposalRequest.contactEmail);
                        track email
                      ) {
                        <div class="text-break">{{ email }}</div>
                      }
                    </dd>
                  </div>
                }
              </dl>
            </div>
          </div>
        </app-display-card>
      </div>
    </div>

    <!-- Schedule -->
    <div class="row mb-3">
      <div class="col">
        <app-display-card [innerPanel]="true">
          <div class="qsb-section-head">
            <h3 class="mb-0">Schedule</h3>
          </div>
          <div class="row g-3">
            <div class="col-md-4">
              <div class="review-stat">
                <span class="review-stat__label">Reminder date</span>
                <span class="review-stat__value">
                  {{ (ProposalRequest.reminderDate | date: 'MM/dd/y') || '—' }}
                </span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="review-stat">
                <span class="review-stat__label">Bid due date</span>
                <span class="review-stat__value">
                  {{ ProposalRequest.dueDate | date: 'MM/dd/y' }}
                </span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="review-stat">
                <span class="review-stat__label">Work start date</span>
                <span class="review-stat__value">
                  {{ ProposalRequest.startDate | date: 'MM/dd/y' }}
                </span>
              </div>
            </div>
          </div>
        </app-display-card>
      </div>
    </div>

    <!-- Pricing (line items) -->
    @if (
      ProposalRequest.ProposalRequestLineItems &&
      ProposalRequest.ProposalRequestLineItems.length > 0
    ) {
      <div class="row mb-3">
        <div class="col">
          <app-display-card [innerPanel]="true">
            <div class="qsb-section-head">
              <h3 class="mb-0">Pricing</h3>
            </div>
            <ol class="review-line-items">
              @for (
                ProposalRequestLineItem of ProposalRequest.ProposalRequestLineItems;
                track ProposalRequestLineItem
              ) {
                <li>{{ ProposalRequestLineItem.text }}</li>
              }
            </ol>
          </app-display-card>
        </div>
      </div>
    }

    <!-- Bid instructions -->
    @if (ProposalRequest.instructions) {
      <div class="row mb-3">
        <div class="col">
          <app-display-card [innerPanel]="true">
            <div class="qsb-section-head">
              <h3 class="mb-0">Bid instructions</h3>
            </div>
            <p class="review-instructions mb-0">
              {{ ProposalRequest.instructions }}
            </p>
          </app-display-card>
        </div>
      </div>
    }

    <!-- Bid files -->
    @if (
      ProposalRequest.ProposalRequestFiles &&
      ProposalRequest.ProposalRequestFiles.length > 0
    ) {
      <div class="row mb-3">
        <div class="col">
          <app-display-card [innerPanel]="true">
            <div class="qsb-section-head">
              <h3 class="mb-0">Bid files</h3>
            </div>
            <div class="row g-3">
              @for (
                ProposalRequestFile of ProposalRequest.ProposalRequestFiles;
                track ProposalRequestFile
              ) {
                <div class="col-md-6">
                  <div class="review-file">
                    <i class="bi bi-paperclip review-file__icon"></i>
                    <div class="review-file__body">
                      <a
                        href="javascript:void(0)"
                        class="review-file__name"
                        (click)="
                          downloadProposalRequestFile(ProposalRequestFile)
                        "
                      >
                        {{ ProposalRequestFile.File?.filename || '' }}
                      </a>
                      <span class="review-file__meta">
                        {{ ProposalRequestFile.File?.filesize || '' }}
                      </span>
                    </div>
                  </div>
                </div>
              }
            </div>
          </app-display-card>
        </div>
      </div>
    }

    <!-- Vendor cards -->
    <ng-template
      #ProposalRequestVendorCollection
      let-ProposalRequestVendors="ProposalRequestVendors"
    >
      <div class="row g-3">
        @for (
          ProposalRequestVendor of ProposalRequestVendors;
          track ProposalRequestVendor
        ) {
          <div class="col-md-6">
            <div class="vendor-card">
              <div class="vendor-card__head">
                <div class="vendor-card__name">
                  {{ ProposalRequestVendor.legalName }}
                </div>
                @if (ProposalRequestVendor.dba) {
                  <div class="vendor-card__dba">
                    DBA: {{ ProposalRequestVendor.dba }}
                  </div>
                }
              </div>
              <dl class="vendor-card__details">
                <div class="vendor-card__row">
                  <dt>Bid contact</dt>
                  <dd>
                    {{ ProposalRequestVendor.firstName }}
                    {{ ProposalRequestVendor.lastName }}
                  </dd>
                </div>
                @if (ProposalRequestVendor.email) {
                  <div class="vendor-card__row">
                    <dt>Email</dt>
                    <dd class="text-break">
                      {{ ProposalRequestVendor.email }}
                    </dd>
                  </div>
                }
                <div class="vendor-card__row">
                  <dt>Phone</dt>
                  <dd>
                    {{ ProposalRequestVendor.phoneExt || '' }}
                    {{ ProposalRequestVendor.phone }}
                  </dd>
                </div>
                @if (ProposalRequestVendor.phone2) {
                  <div class="vendor-card__row">
                    <dt>Work phone</dt>
                    <dd>
                      {{ ProposalRequestVendor.phone2Ext || '' }}
                      {{ ProposalRequestVendor.phone2 }}
                    </dd>
                  </div>
                }
              </dl>
            </div>
          </div>
        }
      </div>
    </ng-template>

    @if (ProposalRequestViveVendors.length > 0) {
      <div class="row mb-3">
        <div class="col">
          <app-display-card [innerPanel]="true">
            <div class="qsb-section-head">
              <h3 class="mb-0">VIVE vendors</h3>
              <span class="qsb-section-count">
                {{ ProposalRequestViveVendors.length }}
              </span>
            </div>
            <ng-container
              *ngTemplateOutlet="
                ProposalRequestVendorCollection;
                context: {
                  ProposalRequestVendors: ProposalRequestViveVendors
                }
              "
            ></ng-container>
          </app-display-card>
        </div>
      </div>
    }

    @if (ProposalRequestNonViveVendors.length > 0) {
      <div class="row mb-3">
        <div class="col">
          <app-display-card [innerPanel]="true">
            <div class="qsb-section-head">
              <h3 class="mb-0">Unregistered vendors</h3>
              <span class="qsb-section-count">
                {{ ProposalRequestNonViveVendors.length }}
              </span>
            </div>
            <ng-container
              *ngTemplateOutlet="
                ProposalRequestVendorCollection;
                context: {
                  ProposalRequestVendors: ProposalRequestNonViveVendors
                }
              "
            ></ng-container>
          </app-display-card>
        </div>
      </div>
    }
  </div>
}
